import DosRejectedComment from './model';
import create from './create';

DosRejectedComment.create = create;

export default DosRejectedComment;



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/DosRejectedComment/index.js